<template>
  <div class="flex flex-col justify-between h-full">
    <div class="flex flex-col space-y-4">
      <h1 class="text-2xl sm:text-4xl font-semibold">Takk for din stemme!</h1>
      <p>Dersom du ønsker å endre din stemme, bare oppdater siden.</p>
      <p>PS: Det er ikke mulig for noen å se hva du stemte <span class="text-gray-400">(med mindre du er den eneste som stemte, eller det ble enstemmig, da...)</span>.</p>
    </div>
  </div>
</template>
